import { render, staticRenderFns } from "./CompanyAuthorizationsTable.vue?vue&type=template&id=9a2e1338&scoped=true&"
import script from "./CompanyAuthorizationsTable.vue?vue&type=script&lang=js&"
export * from "./CompanyAuthorizationsTable.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAuthorizationsTable.vue?vue&type=style&index=0&id=9a2e1338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2e1338",
  null
  
)

export default component.exports